export default __webpack_public_path__ + "static/media/fence1.a4aedaa0.jpg";